export default "__VITE_ASSET__CeJd5gsx__"